module.exports = __webpack_public_path__ + "media/images/steps/png/155-job-search-1-7d2714662e9d0f161284bdb7e6b764ba.png";